import template from './add-outside-person-summary.html';

export class AddOutsidePersonSummaryController {
  constructor($log, PinCodeService) {
    'ngInject';
    this.$log = $log;
    this.PinCodeService = PinCodeService;
  }

  $onInit() {
    this.headerTitle = 'Podsumowanie';
  }

  unregister() {
    this.onUnregisterClick();
  }
}

export const AddOutsidePersonSummary = {
  bindings: {
    headerTitle: '=',
    outsidePerson: '<',
    onUnregisterClick: '&'
  },
  controller: AddOutsidePersonSummaryController,
  template
};
